import { useApp } from "../context/AppContext";

// Окремий модуль «Генератор статей». Доступ лише iz@ / ib@; решті — заглушка «в розробці».
const ALLOWED = ["iz@svitlo.agency", "ib@svitlo.agency"];

export default function ArticleGenView() {
  const { currentUser } = useApp();
  const allowed = ALLOWED.includes(currentUser);

  if (!allowed) {
    return (
      <div style={{ minHeight: "60vh", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", textAlign: "center", gap: 14, color: "#9aa0c0" }}>
        <div style={{ fontSize: 54 }}>🚧</div>
        <div style={{ fontSize: 22, fontWeight: 800, color: "#e6e8f2" }}>Модуль у розробці</div>
        <div style={{ fontSize: 14, maxWidth: 420 }}>Генератор статей скоро зʼявиться. Наразі доступ обмежено.</div>
      </div>
    );
  }

  return (
    <iframe
      title="Генератор статей"
      src="/article-gen/"
      style={{ width: "100%", height: "calc(100vh - 58px)", border: 0, display: "block" }}
    />
  );
}
